"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var md5_1 = __importDefault(require("md5"));
var ExtError_1 = require("../modules/ExtError");
var ext_1 = require("../util/ext");
var service_1 = __importDefault(require("../util/service"));
var _authRejected = false;
var _instanceMap = new Map();
var ExtUserAuth = /** @class */ (function () {
    function ExtUserAuth(logger, extMain) {
        this.logger = logger;
        this.extMain = extMain;
    }
    ExtUserAuth.clear = function () {
        _authRejected = false;
        _instanceMap = new Map();
    };
    ExtUserAuth.getInstance = function (logger, extMain) {
        if (!_instanceMap.get(extMain.extUuid)) {
            _instanceMap.set(extMain.extUuid, new ExtUserAuth(logger, extMain));
        }
        return _instanceMap.get(extMain.extUuid);
    };
    ExtUserAuth.prototype.getAuthTempKey = function () {
        return md5_1["default"]("extComp_tempAuth_" + this.extMain.extUuid);
    };
    ExtUserAuth.prototype.getAuthTemp = function () {
        var key = this.getAuthTempKey();
        try {
            var authTemp = window.sessionStorage.getItem(key);
            if (authTemp) {
                window.sessionStorage.removeItem(key);
            }
            return Promise.resolve(!!authTemp);
        }
        catch (err) {
            return Promise.resolve(false);
        }
    };
    ExtUserAuth.prototype.setAuthTemp = function () {
        var key = this.getAuthTempKey();
        try {
            window.sessionStorage.setItem(key, '1');
            return Promise.resolve();
        }
        catch (_) {
            return Promise.resolve();
        }
    };
    ExtUserAuth.prototype.initAuth = function (adapter, extEndpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, auth, isAnchor, authTemp, _a, jwt, expire, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.debug('初始化授权');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 13, , 14]);
                        return [4 /*yield*/, adapter.getUserId()];
                    case 2:
                        userId = _b.sent();
                        auth = false;
                        if (!userId.lUid) return [3 /*break*/, 8];
                        this.logger.debug('用户已登陆');
                        isAnchor = adapter.getStreamerUid() === userId.lUid;
                        if (!isAnchor) return [3 /*break*/, 3];
                        this.logger.debug('用户为当前直播间的主播，直接获得授权');
                        auth = true;
                        return [3 /*break*/, 7];
                    case 3:
                        this.logger.debug('用户为普通观众，查看是否有临时授权', { uid: userId.lUid });
                        return [4 /*yield*/, this.getAuthTemp()];
                    case 4:
                        authTemp = _b.sent();
                        if (!authTemp) return [3 /*break*/, 6];
                        this.logger.debug('用户获得临时授权，调用远程服务设置授权状态', { uid: userId.lUid });
                        return [4 /*yield*/, this.userExtAuthorize(extEndpoint, adapter)];
                    case 5:
                        _b.sent();
                        auth = true;
                        return [3 /*break*/, 7];
                    case 6:
                        this.logger.debug('用户没有获得临时授权', { uid: userId.lUid });
                        _b.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.logger.debug('用户没有登录');
                        _b.label = 9;
                    case 9:
                        if (!auth) return [3 /*break*/, 11];
                        this.logger.debug('用户同意授权，调用远程服务获取jwt');
                        return [4 /*yield*/, service_1["default"].getJWT(adapter, this.extMain)];
                    case 10:
                        _a = _b.sent(), jwt = _a.jwt, expire = _a.expire;
                        this.logger.debug('初始化授权完成，已授权，并加入授权列表', { jwt: jwt, expire: expire });
                        this.authResolved = { jwt: jwt, expire: expire, time: new Date().valueOf() };
                        return [2 /*return*/, Promise.resolve()];
                    case 11:
                        this.logger.debug('初始化授权完成，未授权，等待用户授权');
                        return [2 /*return*/, Promise.resolve()];
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        err_1 = _b.sent();
                        this.logger.warn('初始化授权失败', { err: err_1.message });
                        return [2 /*return*/, Promise.resolve()];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    ExtUserAuth.prototype.isAuthValid = function (authResp) {
        var current = new Date().valueOf();
        return (current - authResp.time) < Math.min(300000, (authResp.expire - 300) * 1000);
    };
    ExtUserAuth.prototype.getAuth = function (adapter, extEndpoint, container) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, jwt, expire, authResp, userId, p, err_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.debug('获取授权');
                        if (!_authRejected) return [3 /*break*/, 1];
                        this.logger.debug('之前已经拒绝过授权，直接拒绝');
                        return [2 /*return*/, Promise.reject(new ExtError_1.ExtRejectAuthError())];
                    case 1:
                        if (!this.authResolved) return [3 /*break*/, 6];
                        this.logger.debug('授权过，判断是否过期');
                        return [4 /*yield*/, this.isAuthValid(this.authResolved)];
                    case 2:
                        if (!_b.sent()) return [3 /*break*/, 3];
                        this.logger.debug('授权仍未过期，直接使用');
                        return [2 /*return*/, Promise.resolve(this.authResolved)];
                    case 3:
                        this.logger.debug('授权过期，重新授权');
                        return [4 /*yield*/, service_1["default"].getJWT(adapter, this.extMain)];
                    case 4:
                        _a = _b.sent(), jwt = _a.jwt, expire = _a.expire;
                        authResp = { jwt: jwt, expire: expire, time: new Date().valueOf() };
                        this.logger.debug('授权成功', { authResp: authResp });
                        this.authResolved = authResp;
                        return [2 /*return*/, Promise.resolve(authResp)];
                    case 5: return [3 /*break*/, 19];
                    case 6: return [4 /*yield*/, adapter.getUserId()];
                    case 7:
                        userId = _b.sent();
                        if (!userId.lUid) return [3 /*break*/, 8];
                        this.logger.debug('用户已登录，调用远程服务获取授权信息');
                        if (this.authPending) {
                            this.logger.debug('当前小程序正在授权中，等待授权结果');
                            return [2 /*return*/, this.authPending];
                        }
                        else {
                            p = this.getUserExtAuthorizeInfo(extEndpoint, adapter).then(function (isAuth) {
                                if (isAuth) {
                                    _this.logger.debug('用户已授权');
                                }
                                else {
                                    _this.logger.debug('用户未授权，弹出提示框询问用户是否授权');
                                    return adapter.showAuthConfirmModal(_this.extMain, extEndpoint, container).then(function () {
                                        _this.logger.debug('用户同意授权，调用远程服务设置授权信息');
                                        return _this.userExtAuthorize(extEndpoint, adapter);
                                    }, function (err) {
                                        _this.logger.debug('用户不同意授权，记录状态');
                                        _authRejected = true;
                                        throw err;
                                    });
                                }
                            }).then(function () {
                                _this.logger.debug('用户授权完毕，调用远程服务获取jwt');
                                return service_1["default"].getJWT(adapter, _this.extMain);
                            }).then(function (_a) {
                                var jwt = _a.jwt, expire = _a.expire;
                                _this.authPending = null;
                                var authResp = { jwt: jwt, expire: expire, time: new Date().valueOf() };
                                _this.logger.debug('授权成功', { authResp: authResp });
                                _this.authResolved = authResp;
                                return Promise.resolve(authResp);
                            });
                            this.authPending = p;
                            return [2 /*return*/, p];
                        }
                        return [3 /*break*/, 19];
                    case 8:
                        if (!ext_1.isNeedAuth(extEndpoint)) return [3 /*break*/, 13];
                        this.logger.debug('用户未登录，先询问是否授权');
                        _b.label = 9;
                    case 9:
                        _b.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, adapter.showAuthConfirmModal(this.extMain, extEndpoint, container)];
                    case 10:
                        _b.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        err_2 = _b.sent();
                        this.logger.debug('用户不同意授权，记录状态');
                        _authRejected = true;
                        return [2 /*return*/, Promise.reject(err_2)];
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        this.logger.debug('该小程序不需要显式授权，不弹出授权框');
                        _b.label = 14;
                    case 14:
                        this.logger.debug('用户同意授权，设置临时授权状态');
                        return [4 /*yield*/, this.setAuthTemp()];
                    case 15:
                        _b.sent();
                        if (!ext_1.isNeedAuth(extEndpoint)) return [3 /*break*/, 17];
                        this.logger.debug('调用登录');
                        return [4 /*yield*/, adapter.login()];
                    case 16:
                        _b.sent();
                        return [3 /*break*/, 18];
                    case 17:
                        this.logger.debug('不需要授权，返回一个空的jwt');
                        _b.label = 18;
                    case 18: return [2 /*return*/, { jwt: '', expire: 0, time: 0 }];
                    case 19: return [2 /*return*/];
                }
            });
        });
    };
    ExtUserAuth.prototype.getUserExtAuthorizeInfo = function (extEndpoint, adapter) {
        if (ext_1.isNeedAuth(extEndpoint)) {
            return service_1["default"].getUserExtAuthorizeInfo(adapter, this.extMain);
        }
        else {
            return Promise.resolve(true);
        }
    };
    ExtUserAuth.prototype.userExtAuthorize = function (extEndpoint, adapter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ext_1.isNeedAuth(extEndpoint)) return [3 /*break*/, 2];
                        return [4 /*yield*/, service_1["default"].userExtAuthorize(adapter, this.extMain)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                    case 2: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    return ExtUserAuth;
}());
exports["default"] = ExtUserAuth;
